import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import circleImage from "../../../images/Circle.webp";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الدائرة - احسب نصف القطر، القطر، المحيط، والمساحة بسهولة";
const DESCRIPTION =
  "استخدم هذه الحاسبة لحساب نصف القطر، القطر، المحيط، والمساحة لأي دائرة بخطوات بسيطة وسريعة. احصل على حلول دقيقة وفورية.";
const KEYWORDS =
  "دائرة، محيط الدائرة، مساحة الدائرة، نصف القطر، القطر، حاسبة الدائرة، حساب الدائرة، قياسات الدائرة";
const OG_URL = "https://do-calculate.com/calculator/ar/circle-calculator";
function CircleCalculator() {
  const [radius, setRadius] = useState("");
  const [diameter, setDiameter] = useState("");
  const [circumference, setCircumference] = useState("");
  const [area, setArea] = useState("");
  const [error, setError] = useState("");
  const [explanation, setExplanation] = useState("");
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const handleCalculate = () => {
    setFieldsDisabled(true);
    let calculatedRadius,
      calculatedDiameter,
      calculatedCircumference,
      calculatedArea;
    let explanationText = "";
    if (radius) {
      const radiusValue = parseFloat(radius);
      if (isNaN(radiusValue) || radiusValue < 0) {
        setError("الرجاء إدخال نصف قطر صحيح");
        return;
      }
      calculatedRadius = radiusValue;
      calculatedDiameter = (2 * radiusValue).toFixed(2);
      calculatedCircumference = (2 * Math.PI * radiusValue).toFixed(2);
      calculatedArea = (Math.PI * radiusValue * radiusValue).toFixed(2);
      explanationText = `نصف القطر المدخل: ${radiusValue} سم
      \nطول القطر = 2 * ${radiusValue} = ${calculatedDiameter} سم
      \nمحيط الدائرة = 2 * π * ${radiusValue} = ${calculatedCircumference} سم
      \nمساحة الدائرة = π * ${radiusValue}² = ${calculatedArea} سم²`;
    } else if (diameter) {
      const diameterValue = parseFloat(diameter);
      if (isNaN(diameterValue) || diameterValue < 0) {
        setError("الرجاء إدخال قطر صحيح");
        return;
      }
      calculatedDiameter = diameterValue;
      calculatedRadius = (diameterValue / 2).toFixed(2);
      calculatedCircumference = (Math.PI * diameterValue).toFixed(2);
      calculatedArea = (Math.PI * Math.pow(diameterValue / 2, 2)).toFixed(2);
      explanationText = `طول القطر المدخل: ${diameterValue} سم
      \nنصف القطر = ${diameterValue} / 2 = ${calculatedRadius} سم
      \nمحيط الدائرة = π * ${diameterValue} = ${calculatedCircumference} سم
      \nمساحة الدائرة = π * (${diameterValue} / 2)² = ${calculatedArea} سم²`;
    } else if (circumference) {
      const circumferenceValue = parseFloat(circumference);
      if (isNaN(circumferenceValue) || circumferenceValue < 0) {
        setError("الرجاء إدخال محيط صحيح");
        return;
      }
      calculatedCircumference = circumferenceValue;
      calculatedRadius = (circumferenceValue / (2 * Math.PI)).toFixed(2);
      calculatedDiameter = (circumferenceValue / Math.PI).toFixed(2);
      calculatedArea = (
        Math.PI * Math.pow(circumferenceValue / (2 * Math.PI), 2)
      ).toFixed(2);
      explanationText = `محيط الدائرة المدخل: ${circumferenceValue} سم
      \nنصف القطر = ${circumferenceValue} / (2 * π) = ${calculatedRadius} سم
      \nطول القطر = ${circumferenceValue} / π = ${calculatedDiameter} سم
      \nمساحة الدائرة = π * (${circumferenceValue} / (2 * π))² = ${calculatedArea} سم²`;
    } else if (area) {
      const areaValue = parseFloat(area);
      if (isNaN(areaValue) || areaValue < 0) {
        setError("الرجاء إدخال مساحة صحيحة");
        return;
      }
      calculatedArea = areaValue;
      calculatedRadius = Math.sqrt(areaValue / Math.PI).toFixed(2);
      calculatedDiameter = (2 * Math.sqrt(areaValue / Math.PI)).toFixed(2);
      calculatedCircumference = (
        2 *
        Math.PI *
        Math.sqrt(areaValue / Math.PI)
      ).toFixed(2);
      explanationText = `مساحة الدائرة المدخلة: ${areaValue} سم²
      \nنصف القطر = √(${areaValue} / π) = ${calculatedRadius} سم
      \nطول القطر = 2 * √(${areaValue} / π) = ${calculatedDiameter} سم
      \nمحيط الدائرة = 2 * π * √(${areaValue} / π) = ${calculatedCircumference} سم`;
    } else {
      setError(
        "الرجاء إدخال معلومات صحيحة (نصف القطر أو القطر أو المحيط أو المساحة)"
      );
      return;
    }
    setRadius(calculatedRadius);
    setDiameter(calculatedDiameter);
    setCircumference(calculatedCircumference);
    setArea(calculatedArea);
    setExplanation(explanationText);
    setError("");
  };
  const handleReset = () => {
    setRadius("");
    setDiameter("");
    setCircumference("");
    setArea("");
    setExplanation("");
    setError("");
    setFieldsDisabled(false);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  استخدم هذه الالة الحاسبة للدائرة من اجل حساب و ايجاد محيط
                  الدائره ومساحتها وطول القطر.
                  <br /> يتم استخدام الدائرة في العديد من التطبيقات الهندسية
                  والرياضية،
                  <br /> ويتم تعريف الدائرة على أنها مجموعة من النقاط التي تبعد
                  مسافة ثابتة عن نقطة معينة تسمى المركز.
                  <br />
                  يمكنك أيضًا استخدام هذه الأداة للتحقق من نتائجك أو لتعلم كيفية
                  إجراء هذه الحسابات يدويًا.
                </p>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب نصف قطر الدائرة</h2>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <p>
                    يرجى إدخال حقل واحد فقط من الحقول التالية: نصف القطر أو
                    القطر أو المحيط أو المساحة
                  </p>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">نصف القطر (r)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفر نصف القطر"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                        disabled={fieldsDisabled}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">طول القطر (d)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفر القطر"
                        value={diameter}
                        onChange={(e) => setDiameter(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                        disabled={fieldsDisabled}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          محيط الدائرة (C)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفر المحيط"
                        value={circumference}
                        onChange={(e) => setCircumference(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                        disabled={fieldsDisabled}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          مساحة الدائرة (A)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفرت المساحة"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                        disabled={fieldsDisabled}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="d-flex m-2">
                      <button
                        className="btn btn-success"
                        style={{ fontSize: "20px", marginLeft: "10px" }}
                        onClick={handleCalculate}
                        disabled={fieldsDisabled}
                      >
                        احسب                      </button>
                      <button
                        className="text-white bg-secondary"
                        style={{ fontSize: "20px" }}
                        onClick={handleReset}
                      >
                        إعادة تعيين
                      </button>
                    </div>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      explanation && (
                        <div className="p-3 mb-2 bg-success text-white">
                          {explanation.split("\n").map((line, index) => (
                            <p key={index} className="text-white">
                              {line}
                            </p>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-5 text-center">
                <img
                  loading="lazy"
                  src={circleImage}
                  alt="Circle Illustration"
                  width="200"
                  height="200"
                />
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هي الدائرة؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                الدائرة عبارة عن سطح تتساوى فيه مسافة جميع نقاط الحافة عن
                المركز. تستخدم الصيغ التالية في حساب الدائرة. مساحة الدائرة A=pi
                * r^2 والمحيط يساوي U=2 * pi * r ، حيث pi هو ثابت الدائرة (حوالي
                3,14).
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>كيف نحسب نصف قطر الدائرة؟ </h3>
            </div>
            <div className="info-section-body">
              <p>
                تقوم هذه الحاسبة ب حساب نصف قطر الدائرة باستخدام المعطيات
                التالية:
              </p>
              <ol>
                <li>
                  إذا توفر في المعطيات طول القطر (d)، يمكن حساب النصف عن طريق
                  القانون التالي:
                  <br />
                  نصف القطر = القطر / 2
                </li>
                <li>
                  إذا توفرت قيمة محيط الدائرة (C)، يمكن حساب النصف عن طريق
                  القانون التالي:
                  <br />
                  نصف القطر = محيط الدائرة / (2 × π)
                </li>
                <li>
                  إذا توفرت قيمة مساحة الدائرة (A)، يمكن حساب النصف عن طريق
                  القانون التالي:
                  <br />
                  نصف القطر = √(مساحة الدائرة / π)
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CircleCalculator;
